"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var JackpotsListCtl = /** @class */ (function (_super) {
    __extends(JackpotsListCtl, _super);
    function JackpotsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_jp_tag = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_tag; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_jp_amount_view = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_amount_view; });
        _this.dk_jp_amount_money = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_amount_money; });
        _this.dk_jp_amount_to_trigger = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_amount_to_trigger; });
        _this.dk_jp_inc_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_inc_percent; });
        _this.dk_jp_min_amount_to_win = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_min_amount_to_win; });
        _this.dk_jp_max_amount_to_win = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_max_amount_to_win; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_date_last_trigger = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_last_trigger; });
        _this.dk_langs_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.langs_count; });
        _this.dk_jp_can_trigger_check_interval_min = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_can_trigger_check_interval_min; });
        _this.dk_jp_min_view_win_amt = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_min_view_win_amt; });
        _this.dk_jp_max_view_win_amt = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_max_view_win_amt; });
        _this.dk_jp_css_classname = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jp_css_classname; });
        _this._errDialog = errDialog;
        return _this;
    }
    JackpotsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    JackpotsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "jackpot with id [" + id + "] not found !";
    };
    JackpotsListCtl.prototype.LoadData = function (AllBrands, BrandsIdList, onDone) {
        var _this = this;
        webAApi_1.ListBonusJackpotsByBrandIdGet.exec({
            all_brands: AllBrands,
            brand_id_list: BrandsIdList
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    title: resp.list[i].title,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    is_locked: resp.list[i].is_locked,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    jp_min_amount_to_win: resp.list[i].jp_min_amount_to_win,
                    jp_max_amount_to_win: resp.list[i].jp_max_amount_to_win,
                    jp_amount_view: resp.list[i].jp_amount_view,
                    jp_amount_money: resp.list[i].jp_amount_money,
                    jp_amount_to_trigger: resp.list[i].jp_amount_to_trigger,
                    jp_inc_percent: resp.list[i].jp_inc_percent,
                    jp_tag: resp.list[i].jp_tag,
                    langs_count: resp.list[i].langs_count,
                    jp_can_trigger_check_interval_min: resp.list[i].jp_can_trigger_check_interval_min,
                    date_last_trigger: moment(resp.list[i].date_last_trigger_uts_ms).utc(false),
                    jp_min_view_win_amt: resp.list[i].jp_min_view_win_amt,
                    jp_max_view_win_amt: resp.list[i].jp_max_view_win_amt,
                    jp_css_classname: resp.list[i].jp_css_classname
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    JackpotsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusJackpot.exec({
            data: {
                title: data.title,
                description: data.description,
                app_currency_id: data.app_currency_id,
                is_locked: data.is_locked,
                brand_id: data.brand_id,
                jp_min_amount_to_win: data.jp_min_amount_to_win,
                jp_max_amount_to_win: data.jp_max_amount_to_win,
                jp_amount_to_trigger: data.jp_amount_to_trigger,
                jp_inc_percent: data.jp_inc_percent,
                jp_tag: data.jp_tag,
                jp_can_trigger_check_interval_min: data.jp_can_trigger_check_interval_min,
                jp_min_view_win_amt: data.jp_min_view_win_amt,
                jp_max_view_win_amt: data.jp_max_view_win_amt,
                jp_css_classname: data.jp_css_classname
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                description: data.description,
                jp_tag: data.jp_tag,
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title,
                is_locked: data.is_locked,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                jp_min_amount_to_win: data.jp_min_amount_to_win,
                jp_max_amount_to_win: data.jp_min_amount_to_win,
                jp_amount_view: 0,
                jp_amount_money: 0,
                jp_amount_to_trigger: data.jp_amount_to_trigger,
                jp_inc_percent: data.jp_inc_percent,
                date_last_trigger: moment(resp.date_last_trigger_uts_ms).utc(false),
                langs_count: 0,
                jp_can_trigger_check_interval_min: data.jp_can_trigger_check_interval_min,
                jp_min_view_win_amt: data.jp_min_view_win_amt,
                jp_max_view_win_amt: data.jp_max_view_win_amt,
                jp_css_classname: data.jp_css_classname
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    JackpotsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusJackpot.exec({
                data: {
                    bonus_jackpot_id: data.key,
                    title: data.title,
                    description: data.description,
                    jp_tag: data.jp_tag,
                    is_locked: data.is_locked,
                    jp_min_amount_to_win: data.jp_min_amount_to_win,
                    jp_max_amount_to_win: data.jp_max_amount_to_win,
                    jp_amount_to_trigger: data.jp_amount_to_trigger,
                    jp_inc_percent: data.jp_inc_percent,
                    //is_can_interact_with_all_currency: data.is_can_interact_with_all_currency,
                    jp_can_trigger_check_interval_min: data.jp_can_trigger_check_interval_min,
                    //is_send_to_all_players_jackpot_win_message: data.is_send_to_all_players_jackpot_win_message
                    jp_min_view_win_amt: data.jp_min_view_win_amt,
                    jp_max_view_win_amt: data.jp_max_view_win_amt,
                    jp_css_classname: data.jp_css_classname
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.description = data.description;
                _tmp.jp_tag = data.jp_tag;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_locked = data.is_locked;
                _tmp.jp_amount_to_trigger = data.jp_amount_to_trigger;
                _tmp.jp_inc_percent = data.jp_inc_percent;
                // _tmp.is_can_interact_with_all_currency = data.is_can_interact_with_all_currency;
                _tmp.jp_can_trigger_check_interval_min = data.jp_can_trigger_check_interval_min;
                _tmp.jp_min_amount_to_win = data.jp_min_amount_to_win;
                _tmp.jp_max_amount_to_win = data.jp_max_amount_to_win;
                _tmp.jp_min_view_win_amt = data.jp_min_view_win_amt;
                _tmp.jp_max_view_win_amt = data.jp_max_view_win_amt;
                _tmp.jp_css_classname = data.jp_css_classname;
                //_tmp.is_send_to_all_players_jackpot_win_message = data.is_send_to_all_players_jackpot_win_message;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    JackpotsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    JackpotsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusJackpot.exec({ data: { bonus_jackpot_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    JackpotsListCtl.prototype.DoSetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBonusJackpotIsLocked.exec({ data: { bonus_jackpot_id: key, is_locked: IsLocked } }, function (resp) {
                _tmp.is_locked = IsLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return JackpotsListCtl;
}(BaseController_1.BaseController));
exports.JackpotsListCtl = JackpotsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ctl/JackpotsListCtl.ts
// module id = 928
// module chunks = 0